export default "__VITE_ASSET__e3b736ea__"